export const NORMAL_USER = 0;
export const VIRTURL_USER = 1;